import AxiosClient from "../AxiosClient";

export const getNextSalesRecordNo = () => {
  const url = "/api/salesRecord/getTravelSalesRecordNo";
  return AxiosClient.get(url);
};

export const getSalesRecord = (params) => {
  const url = "/api/salesRecord/searchSalesRecord";
  return AxiosClient.post(url, params);
};

export const searchSalesRecordByNo = (salesRecordNo) => {
  if (!salesRecordNo) throw new Error("販売原票番号はNULLできない");
  const url = "/api/salesRecord/searchSalesRecord";
  const params = { salesRecordNo };
  return AxiosClient.post(url, params);
};

export const upsertSalesRecord = (params) => {
  const url = "/api/salesRecord/upsertSalesRecord";
  return AxiosClient.post(url, params);
};

export const upsertStock = (params) => {
  const url = "/api/salesRecord/upsertStock";
  return AxiosClient.post(url, params);
};

export const getSalesReportConfirmation = (params = {}) => {
  const url = `/api/salesRecord/reportConfirmation?date=${params?.date}&period=${params?.period}`;
  return AxiosClient.get(url);
};
